import { Directive, ElementRef, AfterViewInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

@Directive({
  selector: '[appStepperDisableFutureSteps]'
})
export class StepperDisableFutureStepsDirective implements AfterViewInit, OnChanges {

  @Input() stepperDisableFutureSteps = false;

  @Input() startIndex = 0;

  selectedIndex = 0;

  constructor(private el: ElementRef, private host: MatStepper) { }

  ngAfterViewInit() {
    this.host.selectionChange.subscribe({
      next: (event) => {
        this.selectedIndex = event.selectedIndex;
        this.disableFutureSteps();
      }
    });
    this.disableFutureSteps();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.stepperDisableFutureSteps && changes.stepperDisableFutureSteps.currentValue !== changes.stepperDisableFutureSteps.previousValue) {
      this.disableFutureSteps();
    }
  }

  disableFutureSteps() {
    this.el.nativeElement.querySelectorAll('mat-step-header').forEach((item, index) => {
      if (index >= this.startIndex) {
        item.style.pointerEvents = index > this.selectedIndex && this.stepperDisableFutureSteps ? 'none' : 'auto';
      }
    });
  }
}
